export * as gb from './en';
export * as hu from './hu.json';